import * as tslib_1 from "tslib";
import newInboxRuleService from '../services/newInboxRuleService';
import { action } from 'satcheljs/lib/legacy';
import datapoints from '../datapoints';
import { DatapointStatus, returnTopExecutingActionDatapoint } from 'owa-analytics';
import runRule from '../actions/actionCreators/runRuleNow';
import canRunRule from 'owa-inbox-rules-option/lib/utils/canRunRule';
var globalRequestCount = 0;
var requestId = ++globalRequestCount;
export default action('newInboxRuleAction', datapoints.createNewInboxRuleDatapoint)(function newInboxRuleAction(inboxRule, actionSource, onSuccess, onFailure, shouldRunRuleNow) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var datapoint;
        return tslib_1.__generator(this, function (_a) {
            datapoint = returnTopExecutingActionDatapoint();
            return [2 /*return*/, newInboxRuleService(inboxRule)
                    .then(function (response) {
                    // We check to make sure the response we are processing is from the most recent request. This prevents us from showing
                    // the status of a previous request instead of the current one
                    if (requestId != globalRequestCount) {
                        if (!response.WasSuccessful) {
                            logResponseFailure(datapoint, response);
                        }
                        return;
                    }
                    if (response.WasSuccessful) {
                        if (shouldRunRuleNow && canRunRule(response.InboxRule)) {
                            runRule(response.InboxRule);
                        }
                        onSuccess(response.InboxRule);
                    }
                    else {
                        logResponseFailure(datapoint, response);
                        onFailure();
                    }
                })
                    .catch(function (error) {
                    logResponseFailure(datapoint);
                    onFailure();
                })];
        });
    });
});
function logResponseFailure(datapoint, response) {
    var errorMessage = response
        ? 'There was an error when creating a new rule'
        : 'Response WasSuccessful was false';
    datapoint.endWithError(DatapointStatus.ServerError, new Error(errorMessage));
}
//# sourceMappingURL=newInboxRuleAction.js.map